export default __webpack_public_path__ + "static/banner4_mobile-57263c91ec718728d52f174db2461b83.png";